import React from 'react';
import { Button } from '@/Components/ui/button';
import { X } from 'lucide-react';

function CloseButton() {
  return (
    <Button
      variant="outline"
      size="icon"
      className="absolute -right-6 -top-6 w-12 h-12 rounded-full border-2 border-white bg-blue-50 z-10"
    >
      <X className="w-6 h-6" />
    </Button>
  );
}

export default CloseButton;